export const P = {
  bg: '#FDF8F5', card: '#FFFFFF', peach: '#F3E5DE',
  rose: '#C17F74', deep: '#8B5E57', text: '#4A3531',
  muted: '#A38F8B', border: '#EFE3DD', white: '#FFFFFF',
  green: '#6EA882', red: '#B56060', amber: '#C99745',
};
